import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';

/**
 * Gets account stats
 * @returns Account Stats
 */
export function getDashboardAccountStats(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(this).dashboardAccountStatsUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        hasAsset: z.boolean(),
        assetHasLicense: z.boolean(),
        hasVehicle: z.boolean().nullable(),
        hasDriver: z.boolean().nullable(),
        hasVehicleGroup: z.boolean().nullable(),
        hasDriverGroup: z.boolean().nullable(),
        hasMapset: z.boolean(),
      })
    )
  );
}
